import React from "react";
import { connect } from "react-redux";
import { Button, Badge, Popover } from "antd";
import DraggablecompTR from "../Common/DraggablecompTR";
import "./Baselayout.css";
import { selectTargetRolesCount } from "slices/targetRolesSlice";
import HELPERS from "utils/helper";

class TRdropdown extends React.Component {
  state = {
    show: false,
  };

  render() {
    HELPERS.log("TRdropdown rendered with props", this.props);

    const drag = (
      <>
        {React.createElement(() => (
          <div className="ti-dropdown">
            <p
              style={{
                textAlign: "left",
                font: "bold normal normal 18px/24px AvenirBook",
                marginBottom: "1em",
              }}
            >
              My Target Roles
            </p>
            {/* <DraggablecompTR /> */}
            <DraggablecompTR isDone={true}/>
          </div>
        ))}
      </>
    );

    return (
      <>
        <Popover content={drag} trigger="click" placement="bottomRight">
          <Button
            type="text"
            style={{ fontWeight: "bold", color: "#111111" ,fontFamily:'AvenirBook' }}
            onClick={() => {
              this.setState({ show: !this.state.show });
            }}
          >
            MY TARGET ROLES &nbsp;&nbsp;
            <Badge
              count={this.props.count}
              showZero={true}
              style={{
                backgroundColor: "rgb(131, 117, 235)",
                marginTop: "-5px",
                boxShadow: "0 0 0 1px rgb(131, 117, 235)",
              }}
            />
          </Button>
        </Popover>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  count: selectTargetRolesCount(state),
});

export default connect(mapStateToProps)(TRdropdown);
